import React, { PropsWithChildren, useCallback } from "react";
import Button from "../../Button";
import ModalBase, { ModalBaseProps } from "../ModalBase";
import styles from "./styles.module.scss";
import { ReactComponent as Close } from "../../../assets/ic_close.svg";

export interface OnCloseEvent {
  preventGoBack?: boolean;
}

export interface ModalProps extends ModalBaseProps {
  title?: string;
  testID?: string;
  onClose?: (e?: OnCloseEvent) => void;
  buttons?: React.ReactNode;
  onAfterOpen?: () => void;

  positiveButtonText?: string;
  onPressPositive?: () => void;

  negativeButtonText?: string;
  onPressNegative?: () => void;

  defaultFocus?: string;

  addCloseIcon?: boolean;
  addButtons?: boolean;
}
const Modal = (props: PropsWithChildren<ModalProps>) => {
  const {
    title,
    children,
    negativeButtonText,
    onPressNegative,
    buttons,
    positiveButtonText = "OK",
    onClose,
    addCloseIcon,
    addButtons = true,
  } = props;
  const _onRequestClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  const _onPressNegative = useCallback(() => {
    _onPressNegative?.();
  }, []);
  return (
    <ModalBase {...props}>
      {addCloseIcon && (
        <Button
          variant="iconButton"
          className={styles.close}
          onClick={_onRequestClose}
          testID="close"
        >
          <Close />
        </Button>
      )}

      {title && <h2 className={styles.title}>{title}</h2>}

      <div>{children}</div>

      {(buttons || addButtons) && (
        <div className={styles.btnBar}>
          {buttons}
          {!buttons && (
            <>
              {negativeButtonText && onPressNegative && (
                <Button variant={"secondary"} onClick={onPressNegative}>
                  {negativeButtonText}
                </Button>
              )}
              <Button
                variant={"primary"}
                onClick={props.onPressPositive || _onRequestClose}
              >
                {positiveButtonText}
              </Button>
            </>
          )}
        </div>
      )}
    </ModalBase>
  );
};

export default Modal;
export { Modal };
